/**
 * Surveille la taille REELLE d'un canvas.
 *
 * `window.resize` ne suffit pas, et le manque etait visible : la barre d'outils
 * change de hauteur sans que la fenetre bouge (une couleur prelevee a la
 * pipette agrandit la palette, qui passe a la ligne et vole une rangee au
 * tableau). Le moteur gardait alors une taille perimee : les coordonnees du
 * doigt etaient lues sur le rectangle reel, mais le rendu employait l'ancienne
 * geometrie, et le trait apparaissait DECALE du doigt.
 *
 * Un ResizeObserver observe la boite elle-meme, donc tous les cas : rotation,
 * barre d'URL mobile qui se retracte, panneau qui s'ouvre, changement de
 * fenetre. Repli sur `window.resize` la ou il n'existe pas.
 */
export function observeSize(element: Element, onResize: () => void): () => void {
  if (typeof ResizeObserver === 'undefined') {
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }

  // La premiere notification arrive a l'observation : elle ne dit rien de neuf,
  // mais elle ne coute rien non plus et remet le moteur d'accord avec le DOM.
  const observer = new ResizeObserver(() => onResize());
  observer.observe(element);
  return () => observer.disconnect();
}
